export enum SearchBarVariant {
    PrimaryGrey800 = "primaryGrey800",
    PrimaryBlack900 = "primaryBlack900",
    SecondaryGrey800 = "secondaryGrey800",
    SecondaryBlack900 = "secondaryBlack900",
}
